export default __webpack_public_path__ + "static/media/II 2025.5a7b8069.pdf";